// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote-module--quote--QJ-TC","qmarks":"quote-module--qmarks--3T7SL"};